import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { StarIcon } from '../SvgIcon/CommonSvgIcons';
import PopUp from '../PopUp/PopUp';
import TitleWithInfo from '../TitleWithInfo/TitleWithInfo';
import { formatNumber } from '../../utils/NumberFormatter';
import { useDispatch } from 'react-redux';
import { setFilterPanel } from '../../store/redux/slices/filterPanelSlice';
import DrillThroughFilterMenu from '../DrillThroughFilterMenu/DrillThroughFilterMenu';

const BarGraphContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 30px;
  height: 200px; /* Adjust height as needed */
  padding: 10px; /* Adjust padding */
  ${'' /* margin-left: 50px; */}
  justify-content: center;
`;

const Bar = styled.div`
  width: 50px; /* Adjust width of each bar */
  display: flex;
  flex-direction: column-reverse; /* Reverse the column direction to make bars grow from bottom to top */
  align-items: center;
  position: relative;

  &>div: first-child {
    border-radius: 3px 0 0 3px;
  }
`;

const BarValue = styled.span`
  position: absolute;
  top: -20px; /* Adjust top position */
  font-size: 14px; /* Adjust font size */
  color: #636363;
  font-family:inherit;
`;

// const FilledBar = styled.div`
//   height: ${(props) => props.barHeight};
//   width: 100%;
//   background: red;
// `;

const BarLabel = styled.span`
  position: absolute;
  bottom: -30px; /* Adjust bottom position */
  font-size: 14px; /* Adjust font size */
  white-space: nowrap; /* Prevent label text from wrapping */
  overflow: hidden; /* Hide any overflow */
  text-overflow: ellipsis;
  width: ${(props) => (props.width ? props.width : '60px')};
  text-align: center;

  color: #636363;
  font-family:inherit;
`;

const NoDataWrapper = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 20% 1fr min-content;
  gap: 2%;
  padding-top: 5px;
  box-sizing: border-box;

  color: #636363;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;

  min-height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TextWrapper = styled.div`
  // text-align: left;
  // overflow:scroll !important;
  & > * {
    // float: left;
    clear: both;
    margin-bottom: 10px;
    padding: 5px 10px;
  }

  span {
    font: Open Sans;
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 25px;
  }
`;
const Message = styled.div`
  color: #2a2929;
  text-align: left;
  font-family:inherit;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  height: 90px;
  overflow: scroll;
  padding-bottom: 0px !important;
  margin-bottom: 0px;
`;
const StatusValWrapper = styled.div`
  text-align: justify;
  display: flex;
  align-items: center;

  & :first-child {
    height: 12px;
    width: 12px;
    content: ' ';
    display: grid;
    background: ${(props) =>
      props?.summaryVal?.fill ? props?.summaryVal?.fill : ''};
    border-radius: 50%;
    margin-bottom: 0px;
  }

  & :nth-child(2) {
    font-size: 15px;
    font-weight: 400;
    color: black;
    margin-left: 5px;
    margin-bottom: 0px;
  }
`;
const CancelButton = styled.span`
  cursor: pointer;
  float: right;
  margin: 20px 20px 0px 0px;

  color: #000;
  text-align: center;
  font-family:inherit;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
const VerticalBarGraph = ({
  data,
  type = '',
  starRating,
  summary = {},
  title = '',
  showFormatted = false,
  width = '',
  sorted = false,
  handleTabClick,
  drillThroughType,
  showDrillThrough = true,
  isChatter,
}) => {
  // Sample data for the bars

  const [summaryVal, setSummaryVal] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  // const sortedData = data.sort((a, b) => b.value - a.value);

  var sortedData = [];
  if (sorted === false) {
    sortedData = data.sort((a, b) => b.value - a.value);
  } else {
    let baseColors = [
      'rgba(45, 137, 85, 1)', // Darkest
      'rgba(45, 137, 85, 0.8)',
      'rgba(45, 137, 85, 0.6)',
      'rgba(45, 137, 85, 0.4)', // Lightest
      'rgba(45, 137, 85, 0.2)', // Lightest
    ];

    sortedData = [...data]
      .sort((a, b) => b.value - a.value)
      .map((item, index) => ({
        ...item,
        fill: baseColors[index],
      }));
  }

  const maxValue = Math.max(...sortedData.map((item) => item.value));
  const multiplier = 180 / maxValue;
  const handleOpenSummary = (rating) => {
    if (rating.value > 0 && title == 'Emotional_Analysis') {
      setSummaryVal(rating);
      setShowPopup(true);
    }
  };
  const dispatch = useDispatch();
  const [rightClickedBar, setRightClickedBar] = useState(null);
  const [showRightClickPopup, setShowRightClickPopup] = useState(false);
  const [rightClickPosition, setRightClickPosition] = useState({
    top: 0,
    left: 0,
  });
  const barContainerRef = useRef(null);
  const handleBarRightClick = (event, barData) => {
    event.preventDefault();

    if (barContainerRef.current) {
      const rect = barContainerRef.current.getBoundingClientRect();
      const top = event.clientY - rect.top;
      const left = event.clientX - rect.left;

      setRightClickPosition({ top, left });
    }

    setRightClickedBar(barData);
    setShowRightClickPopup(true);
  };

  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowRightClickPopup(false);
      }
    };

    if (showRightClickPopup) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showRightClickPopup]);

  const handleDrillThrough = (data) => {
    var filterPanel = {};
    if (
      data?.name === 'Male' ||
      data?.name === 'Female' ||
      data?.name === 'Unknown'
    ) {
      filterPanel = {
        gender: [data?.name?.toLowerCase()],
      };
    }
    if (data?.name === 'Non Verified' || data?.name === 'Verified') {
      filterPanel = {
        user_type: [data?.name === 'Verified' ? 'True' : 'False'],
      };
    }
    if (drillThroughType === 'posts') {
      filterPanel = {
        search: [{ type: 'post', value: data?.name }],
      };
    }
    if (drillThroughType === 'account') {
      filterPanel = {
        search: [{ type: 'profile', value: data?.name }],
      };
    }
    if (drillThroughType === 'sentiment') {
      filterPanel = {
        sentiment: [
          data?.name === 'Positive' ? 1 : data?.name === 'Negative' ? -1 : 0,
        ],
      };
    }
    if (drillThroughType === 'emotion') {
      filterPanel = {
        emotion: [data?.name?.toLowerCase()],
      };
    }
    if (drillThroughType === 'review') {
      filterPanel = {
        rating: [data?.name?.slice(0, 1)],
      };
    }
    dispatch(setFilterPanel(filterPanel));

    setShowRightClickPopup(false);
    isChatter === true
      ? handleTabClick('commentsTab')
      : handleTabClick('reviewsTab');
  };
  return (
    <BarGraphContainer
      className='pdf-page'
      style={{
        pageBreakInside: 'avoid',
        width: data && data?.length > 0 ? '' : '100%',
        position: 'relative',
      }}
    >
      {sortedData && sortedData?.length > 0 ? (
        sortedData.map((item, index) => (
          <Bar key={index} onClick={() => handleOpenSummary(item)}>
            <div
              onContextMenu={(e) => {
                if (showDrillThrough === true) {
                  handleBarRightClick(e, item);
                }
              }}
              style={{
                height: `${Math.floor(item.value * multiplier) + 2}px`,
                backgroundColor: item.fill || '#353cf7',
                width: '100%',
              }}
            ></div>
            <BarValue title={item?.value}>
              {showFormatted ? formatNumber(item.value) : item?.value}
              <span
                style={{
                  color: '#2a2929',
                }}
              >
                {type}
              </span>{' '}
            </BarValue>
            <BarLabel
              width={width}
              style={{
                color: '#2a2929',
              }}
            >
              {item.name}
            </BarLabel>
          </Bar>
        ))
      ) : (
        <NoDataWrapper>
          {/* No Data Available  */}Insufficient Data
        </NoDataWrapper>
      )}
      {showPopup &&
        summary[summaryVal?.name && summaryVal?.name?.toLowerCase()] && (
          <PopUp
            minWidth={'700px'}
            height={'280px'}
            maxWidth={'700px'}
            onClose={() => setShowPopup(false)}
          >
            {/* <span>cross</span>
          <div>{reviews[reviewMessage]}</div> */}
            <TextWrapper>
              <div>
                <TitleWithInfo title={'Summary '} infoText={``} />
              </div>
              <br />
              <Message>
                {summary[summaryVal?.name && summaryVal?.name?.toLowerCase()]}
              </Message>
              <br />
              <StatusValWrapper summaryVal={summaryVal}>
                <span></span>{' '}
                <span>{`${summaryVal?.name}- ${
                  summaryVal?.value ? summaryVal?.value : 0
                }%`}</span>
              </StatusValWrapper>
              <CancelButton onClick={() => setShowPopup(false)}>
                Close
              </CancelButton>
            </TextWrapper>
          </PopUp>
        )}
      {showRightClickPopup && rightClickedBar && (
        <div
          style={{
            position: 'absolute',
            top: `${rightClickPosition.top}px`,
            left: `${rightClickPosition.left}px`,
            zIndex: 9999,
            background: 'white',
            borderRadius: '6px',
          }}
          ref={popupRef}
        >
          <DrillThroughFilterMenu
            handleDrillThrough={() =>
              handleDrillThrough({
                name: rightClickedBar?.name,
                value: rightClickedBar?.value,
              })
            }
          />
        </div>
      )}
    </BarGraphContainer>
  );
};

export default VerticalBarGraph;
